// extracted by mini-css-extract-plugin
export default {"links":"Links_links__O3fAd","list":"Links_list__unle4","button":"Links_button__Qhl3p","text":"Links_text__kEav8","icon":"Links_icon__DdR8Z"};